var app = angular.module('leonardo');

var FolderService = function(BaseRestService, $q, RestangularProvider) {
  var service = new BaseRestService('document-folders', function(RestangularConfigurer) {
    RestangularConfigurer.addElementTransformer('document-folders', false, function(document_folder) {
      document_folder.addRestangularMethod('moveTo', 'post', 'move');
      document_folder.addRestangularMethod('copyTo', 'post', 'copy');
      document_folder.addRestangularMethod('download', 'get', 'download');
      return document_folder;
    });
  });

  service.download = function(params) {
    return RestangularProvider.all('document-folders').customGET('download', params);
  };

  service.TYPE_ACCOUNT = '0';
  service.TYPE_PORTFOLIO = '1';
  service.TYPE_PROPERTY = '2';
  service.TYPE_NORMAL = '3';
  service.TYPE_SPECIAL = '4';

  service.UPLOAD_FOLDER = '1';
  service.UPLOAD_FILE = '2';

  service.PURPOSE_SUPERUSER_ACCOUNT = '1';
  service.PURPOSE_ACTION_ITEMS = '2';
  service.PURPOSE_ACTION_ITEMS_ATTACHMENTS = '3';
  service.PURPOSE_UNIT_TURNS = '4';
  service.PURPOSE_WORKFLOWS = '5';
  service.PURPOSE_NOTES = '6';
  service.PURPOSE_DYNAMIC_FORMS = '7';
  service.PURPOSE_REPORT_WAREHOUSE = '8';
  service.PURPOSE_ARCHIVE = '9';
  service.showNext = false;
  service.selectedSourceFolders = [];
  service.selectedSourceFiles = [];
  service.isDefaultPropertyChanged = false;


  service.bulkObject = function(account, sector) {
    return {
      account: account,
      name: '',
      linked_flag: false,
      requirements: [],
      visible_by_roles: [],
      editable_by_roles: [],
      sector: sector ? sector : null
    };
  };

  service.moveMultiple = function(params) {
    return RestangularProvider.all('document-folders').customPOST(params, 'move_multiple');
  };


  return service;
};

app.factory('FolderService', ['BaseRestService', '$q', 'Restangular', FolderService]);
